'use client';

import Link from 'next/link';
import type { ReactNode } from 'react';
import { TbBrandMeta, TbBriefcase, TbHelpCircle, TbSourceCode } from 'react-icons/tb';

import type { MegaMenuKey } from './nav';

// Mega-menu bento (estilo Featurebase) dos itens "Funcionalidades" e "Sobre"
// do dock. Estilos escopados em `.mega`. As imagens (funnel/integrations) só
// são buscadas quando o popover abre (o componente só monta quando aberto).
const STYLES = `
.mega { pointer-events:auto; width:100%; max-width:780px; border-radius:22px; padding:14px;
  background:linear-gradient(180deg, rgba(32,27,48,.92), rgba(20,17,30,.88));
  backdrop-filter:blur(26px) saturate(170%); -webkit-backdrop-filter:blur(26px) saturate(170%);
  border:1px solid rgba(222,219,246,.14);
  box-shadow:0 30px 70px rgba(0,0,0,.6), inset 0 1px 0 rgba(255,255,255,.12);
  animation:mega-drop .22s cubic-bezier(.16,1,.3,1); }
@keyframes mega-drop { from{opacity:0; transform:translateY(-8px);} to{opacity:1; transform:translateY(0);} }
.mega .bento { display:grid; grid-template-columns:1fr 1fr; grid-auto-rows:auto; gap:12px; }
.mega .c-tall { grid-column:1; grid-row:1 / span 3; }
.mega .c-img { grid-column:2; grid-row:1; }
.mega .c-i1 { grid-column:2; grid-row:2; }
.mega .c-i2 { grid-column:2; grid-row:3; }
.mega .card { position:relative; overflow:hidden; border-radius:16px; border:1px solid rgba(222,219,246,.10);
  background:linear-gradient(180deg, rgba(255,255,255,.03), rgba(255,255,255,.008)); text-decoration:none; display:block; transition:all .2s; }
.mega .card:hover { border-color:rgba(144,97,255,.4); transform:translateY(-2px); box-shadow:0 14px 30px -12px rgba(144,97,255,.4); }
.mega .imgarea { position:relative; height:150px; overflow:hidden; -webkit-mask-image:linear-gradient(to bottom,#000 60%,transparent); mask-image:linear-gradient(to bottom,#000 60%,transparent); }
.mega .c-tall .imgarea { height:240px; }
.mega .coverimg { position:absolute; inset:0; width:100%; height:100%; object-fit:cover; }
.mega .coverimg.tl { object-position:left top; }
.mega .cardft { padding:13px 15px 15px; }
.mega .cardft .t { font-size:14px; font-weight:700; color:#fff; }
.mega .cardft .d { font-size:12px; color:#8B88A8; margin-top:3px; line-height:1.45; }
.mega .codewin { position:absolute; inset:14px; border-radius:10px; background:#0c0a14; border:1px solid rgba(222,219,246,.08); overflow:hidden; box-shadow:0 10px 30px rgba(0,0,0,.4); }
.mega .codebar { height:26px; display:flex; align-items:center; gap:6px; padding:0 11px; border-bottom:1px solid rgba(222,219,246,.06); background:rgba(255,255,255,.02); }
.mega .codebar i { width:8px; height:8px; border-radius:50%; display:inline-block; }
.mega .cr{background:#ff5f57;} .mega .cy{background:#febc2e;} .mega .cg{background:#28c840;}
.mega .codebar span { margin-left:6px; font-family:'JetBrains Mono',monospace; font-size:9px; color:#6E6B86; }
.mega .codebody { padding:12px 14px; font-family:'JetBrains Mono',monospace; font-size:11.5px; line-height:1.75; white-space:pre; color:#8B88A8; }
.mega .codebody .k{color:#a884ff;} .mega .codebody .s{color:#7ee787;} .mega .codebody .n{color:#ffb86b;} .mega .codebody .b{color:#79c0ff;}
.mega .blogwin { position:absolute; inset:14px; border-radius:10px; background:#0c0a14; border:1px solid rgba(222,219,246,.08); overflow:hidden; box-shadow:0 10px 30px rgba(0,0,0,.4); }
.mega .blogcover { height:48px; position:relative; background:radial-gradient(120% 160% at 15% 0%, rgba(144,97,255,.45), transparent 60%), linear-gradient(120deg, rgba(159,17,206,.4), rgba(144,97,255,.25)); }
.mega .blogcover::after { content:""; position:absolute; inset:0; background-image:linear-gradient(rgba(255,255,255,.06) 1px,transparent 1px),linear-gradient(90deg,rgba(255,255,255,.06) 1px,transparent 1px); background-size:14px 14px; opacity:.5; }
.mega .blogtag { position:absolute; left:10px; bottom:8px; z-index:1; font-family:'JetBrains Mono',monospace; font-size:8px; letter-spacing:.12em; text-transform:uppercase; color:#fff; background:rgba(0,0,0,.4); padding:3px 8px; border-radius:999px; border:1px solid rgba(255,255,255,.22); }
.mega .blogbody { padding:11px 13px; }
.mega .blogtitle { font-size:13.5px; font-weight:800; color:#fff; line-height:1.25; letter-spacing:-.01em; }
.mega .blogmeta { display:flex; align-items:center; gap:7px; margin-top:8px; }
.mega .blogav { width:16px; height:16px; border-radius:50%; background:linear-gradient(120deg,#EAE7FB,#9061FF 75%); flex:none; }
.mega .blogmeta span { font-size:9px; color:#6E6B86; font-family:'JetBrains Mono',monospace; }
.mega .blogline { height:5px; border-radius:3px; background:rgba(222,219,246,.09); margin-top:9px; }
.mega .iconcard { display:flex; align-items:center; gap:13px; padding:13px 15px; }
.mega .iconbox { width:42px; height:42px; border-radius:12px; flex:none; display:grid; place-items:center; color:#c2a9ff; background:linear-gradient(135deg, rgba(144,97,255,.18), rgba(144,97,255,.05)); border:1px solid rgba(144,97,255,.28); transition:transform .25s cubic-bezier(.16,1,.3,1); }
.mega .iconbox svg { width:20px; height:20px; }
.mega .iconcard:hover .iconbox { transform:translateY(-3px) rotate(-6deg) scale(1.06); }
.mega .iconcard .t { font-size:13px; font-weight:700; color:#fff; }
.mega .iconcard .d { font-size:11.5px; color:#8B88A8; margin-top:1px; }
`;

const CODE_HTML = `<span class="b">POST</span> /v1/track
{
  <span class="k">"event"</span>: <span class="s">"Purchase"</span>,
  <span class="k">"value"</span>: <span class="n">497.00</span>,
  <span class="k">"currency"</span>: <span class="s">"BRL"</span>,
  <span class="k">"email_hash"</span>: <span class="s">"a1b2…"</span>,
  <span class="k">"fbp"</span>: <span class="s">"fb.1.17…"</span>,
  <span class="k">"server_side"</span>: <span class="b">true</span>
}
<span class="b">→ 200</span> <span class="s">enviado à Meta ✓</span>`;

interface IconCardProps {
  href: string;
  icon: ReactNode;
  title: string;
  desc: string;
  className: string;
  onNavigate: () => void;
}

function IconCard({ href, icon, title, desc, className, onNavigate }: IconCardProps) {
  return (
    <Link href={href as never} onClick={onNavigate} className={`card iconcard ${className}`}>
      <span className="iconbox">{icon}</span>
      <div>
        <div className="t">{title}</div>
        <div className="d">{desc}</div>
      </div>
    </Link>
  );
}

interface Props {
  menu: MegaMenuKey;
  onNavigate: () => void;
}

export function PublicMegaMenu({ menu, onNavigate }: Props) {
  return (
    <div className="mega">
      <style dangerouslySetInnerHTML={{ __html: STYLES }} />
      {menu === 'func' ? (
        <div className="bento">
          <Link href={'/ajuda/comecar' as never} onClick={onNavigate} className="card c-tall">
            <div className="imgarea">
              <div className="codewin">
                <div className="codebar">
                  <i className="cr" />
                  <i className="cy" />
                  <i className="cg" />
                  <span>track.ts</span>
                </div>
                <div className="codebody" dangerouslySetInnerHTML={{ __html: CODE_HTML }} />
              </div>
            </div>
            <div className="cardft">
              <div className="t">Como funciona o Trakd</div>
              <div className="d">Tracking server-side em 3 passos: conecte, instale e escale.</div>
            </div>
          </Link>

          <Link href={'/docs/integracoes' as never} onClick={onNavigate} className="card c-img">
            <div className="imgarea">
              <img
                src="/megamenu/integrations-v2.webp"
                alt=""
                className="coverimg tl"
                loading="lazy"
              />
            </div>
            <div className="cardft">
              <div className="t">Integrações disponíveis</div>
              <div className="d">Checkouts e gateways BR nativos, prontos pra colar e usar.</div>
            </div>
          </Link>

          <IconCard
            href="/ajuda/conectar-meta"
            icon={<TbBrandMeta />}
            title="Conectar conta Meta"
            desc="Ligue sua conta de anúncios e o pixel."
            className="c-i1"
            onNavigate={onNavigate}
          />
          <IconCard
            href="/ajuda/eventos"
            icon={<TbSourceCode />}
            title="Eventos disparados"
            desc="O que o Trakd manda pra Meta."
            className="c-i2"
            onNavigate={onNavigate}
          />
        </div>
      ) : (
        <div className="bento">
          <Link href={'/sobre' as never} onClick={onNavigate} className="card c-tall">
            <div className="imgarea">
              <img src="/megamenu/funnel.webp" alt="" className="coverimg" loading="lazy" />
            </div>
            <div className="cardft">
              <div className="t">Sobre a Trakd</div>
              <div className="d">
                Quem somos, por que existimos e a missão de devolver os dados pra Meta.
              </div>
            </div>
          </Link>

          <Link href={'/blog' as never} onClick={onNavigate} className="card c-img">
            <div className="imgarea">
              <div className="blogwin">
                <div className="blogcover">
                  <span className="blogtag">Meta Ads · CAPI</span>
                </div>
                <div className="blogbody">
                  <div className="blogtitle">Por que o ROAS do painel mente em 2026</div>
                  <div className="blogmeta">
                    <span className="blogav" />
                    <span>Equipe Trakd · 5 min de leitura</span>
                  </div>
                  <div className="blogline" style={{ width: '100%' }} />
                  <div className="blogline" style={{ width: '92%' }} />
                  <div className="blogline" style={{ width: '76%' }} />
                </div>
              </div>
            </div>
            <div className="cardft">
              <div className="t">Blog</div>
              <div className="d">Conteúdo sobre Meta Ads, CAPI e tracking.</div>
            </div>
          </Link>

          <IconCard
            href="/vagas"
            icon={<TbBriefcase />}
            title="Vagas"
            desc="Construa o Trakd com a gente."
            className="c-i1"
            onNavigate={onNavigate}
          />
          <IconCard
            href="/ajuda"
            icon={<TbHelpCircle />}
            title="Central de ajuda"
            desc="Tutoriais, glossário e FAQ."
            className="c-i2"
            onNavigate={onNavigate}
          />
        </div>
      )}
    </div>
  );
}
